import { useRouteNavigate } from '@features/navigation/hooks/useRouteNavigate'
import { Path } from '../../../routes/paths'
import { useCreateTableDialogStore } from '../stores/useCreateTableDialogStore'
import CreateTableDialog from './CreateTableDialog'

/**
 * The Add Table panel, in the app shell so it outlives whatever opened it
 * (useCreateTableDialogStore). Create opens the new table with its settings;
 * Create & Close stays where you are.
 */
export default function CreateTableDialogHost() {
  const open = useCreateTableDialogStore((state) => state.open)
  const closeCreateTable = useCreateTableDialogStore((state) => state.closeCreateTable)
  const navigate = useRouteNavigate()

  // Mounted only while open, so each opening starts from a blank form.
  if (!open) return null

  return (
    <CreateTableDialog
      open
      onClose={closeCreateTable}
      onCreated={(table, close) => {
        closeCreateTable()
        if (!close)
          navigate(Path.tableViewRecords(table.id, 'all'), { state: { openTableSettings: true } })
      }}
    />
  )
}
